var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C12.6272 4 13.7082 4.44777 14.5052 5.2448C15.3022 6.04183 15.75 7.12283 15.75 8.25C15.75 9.37717 15.3022 10.4582 14.5052 11.2552C13.7082 12.0522 12.6272 12.5 11.5 12.5C10.3728 12.5 9.29183 12.0522 8.4948 11.2552C7.69777 10.4582 7.25 9.37717 7.25 8.25C7.25 7.12283 7.69777 6.04183 8.4948 5.2448C9.29183 4.44777 10.3728 4 11.5 4ZM11.5 21C11.5 21 20 21 20 18.875C20 16.325 15.8562 13.5625 11.5 13.5625C7.14375 13.5625 3 16.325 3 18.875C3 21 11.5 21 11.5 21Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.818741fb322aeedd4d214fa35e5ee7d8.svg";
export { ForwardRef as ReactComponent };